import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

export default function CustomPageLoading() {
  return (
    <Backdrop
      open={true}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        color: '#ffffff',
      }}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
